module.exports = __webpack_public_path__ + "fonts/roboto-medium-webfont.woff";